export class Category {
    constructor(id, title, products, imageUrl, ratio) {
        this.id = id;
        this.title = title;
        this.products = products;
        this.imageUrl = imageUrl;
        this.ratio = ratio;
    }
}
